import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import { ErrorMessage } from "@components/atoms";
import { AddressSummary } from "@components/molecules";
import * as S from "./styles";

/**
 * Review order view showed in checkout.
 */
var CheckoutReview = function CheckoutReview(_ref) {
  var shippingAddress = _ref.shippingAddress,
      billingAddress = _ref.billingAddress,
      shippingMethodName = _ref.shippingMethodName,
      paymentMethodName = _ref.paymentMethodName,
      email = _ref.email,
      errors = _ref.errors;
  var intl = useIntl();
  return React.createElement(S.Wrapper, null, React.createElement(S.Title, {
    "data-cy": "checkoutPageSubtitle"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Summary",
    "id": "@next.components.organisms.CheckoutReview.CheckoutReview.2745385064"
  }, "id", "@next.components.organisms.CheckoutReview.CheckoutReview.2745385064"))), React.createElement(S.Grid, null, React.createElement("section", null, React.createElement(S.SubTitle, {
    "data-cy": "checkoutReviewSectionTitle"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Shipping Address",
    "id": "@next.components.organisms.CheckoutReview.CheckoutReview.2758581442"
  }, "id", "@next.components.organisms.CheckoutReview.CheckoutReview.2758581442"))), React.createElement(AddressSummary, {
    address: shippingAddress,
    email: email
  })), React.createElement("section", null, React.createElement(S.SubTitle, {
    "data-cy": "checkoutReviewSectionTitle"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Billing Address",
    "id": "@next.components.organisms.CheckoutReview.CheckoutReview.4282475982"
  }, "id", "@next.components.organisms.CheckoutReview.CheckoutReview.4282475982"))), React.createElement(AddressSummary, {
    address: billingAddress,
    email: email
  }))), React.createElement(S.ErrorMessages, null, React.createElement(ErrorMessage, {
    errors: errors
  })));
};

export { CheckoutReview };